/**
 * Validates whether navigation should be allowed for a given query and URL parameters.
 * Prevents navigation for empty organic searches while allowing navigation when:
 * - Query has content, OR
 * - Query is empty but filters exist AND user is in filter test variant
 *
 * @param queryValue - The search query value to validate
 * @param urlParams - URL parameters/query object to check for filters
 * @returns true if navigation should be allowed, false if it should be prevented
 */
export const shouldAllowSearchNavigation = (queryValue: string, urlParams: Record<string, unknown> = {}): boolean => {
  // Check if this is an empty query for an organic search (without filters)
  const isEmptyQuery = !queryValue.trim();

  // If query has content, always allow navigation
  return !isEmptyQuery;
};
